import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b0965aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quality-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { style: {"color":"#FA660A"} }
const _hoisted_5 = { class: "bottom" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "不合格项：", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开始时间：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "完成期限：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['quality-list-item', !index && 'quality-list-item-disabled']),
        key: item.id,
        onClick: ($event: any) => (_ctx.toDetail(item, index))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "检查单号：" + _toDisplayString(item.orderid), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.task_name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(item.bad_norm_num || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(item.pool_time_s || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(_toDisplayString(item.pool_time_e || "-"), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['state', `state${item.state}`])
        }, _toDisplayString(item.state_name), 3)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}